<template>
  <el-container style="height: 100%; border: 1px solid #eee">

    <div class="aside">
      <div class="aside-header">
      </div>

      <el-aside width="230px">
        <el-menu :default-openeds="['1', '2', '3']" style="border: 0px;">
          <el-submenu index="1">
            <template slot="title"><i class="el-icon-s-operation"></i>操作历史记录</template>
            <el-menu-item index="1-1" @click="gotoVideoClickHistory">视频观看记录</el-menu-item>
            <el-menu-item index="1-2" @click="gotoMaterialClickHistory">笔记查看记录</el-menu-item>
          </el-submenu>

          <el-submenu index="2">
            <template slot="title"><i class="el-icon-s-grid"></i>订单中心</template>
            <el-menu-item index="2-1" @click="gotoOrderList">订单列表</el-menu-item>
          </el-submenu>

          <el-submenu index="3">
            <template slot="title"><i class="el-icon-user-solid"></i>账户中心</template>
            <el-menu-item index="3-1" @click="gotoUpdatePassword">修改密码</el-menu-item>
          </el-submenu>

        </el-menu>
      </el-aside>
    </div>

    <el-container style="height: 100%;">
<!--      <img style="width: 130px; height: 50px; position: absolute; top: 3px; left: 20px; cursor: pointer;" @click="gotoIndex" src="/static/images/yale_logo_white.png"/>-->
<!--      <el-header style="text-align: right; font-size: 14px; color: white;">-->
<!--        <span>-->
<!--          <i class="fas fa-home" style="margin-right: 4px;"></i>{{phone}}-->
<!--        </span>-->
<!--        <span id="exitLogin" @click="logout">-->
<!--          <i class="fas fa-sign-out-alt" style="margin-left: 10px; margin-right: 4px;"></i>退出-->
<!--        </span>-->
<!--      </el-header>-->

      <el-header style="text-align: right; font-size: 14px; color: white;">
        <span style="position: absolute; left: 20px; cursor: pointer; font-size: 22px;" @click="gotoIndex">BigData On K8s</span>
        <span>
          <i class="fas fa-home" style="margin-right: 4px;"></i>{{phone2}}
        </span>
        <span id="exitLogin" @click="logout">
          <i class="fas fa-sign-out-alt" style="margin-left: 10px; margin-right: 4px;"></i>退出
        </span>
      </el-header>

      <router-view style="border-left: 2px solid #ccc;"/>

<!--      <el-footer style="font-size: 14px; border-left: 2px solid #ccc;">Copyright &copy;{{currentYear}} bigdataonk8s.com 珠海市芽乐科技有限公司 版权所有</el-footer>-->
    </el-container>

  </el-container>
</template>

<script>
// import {mapState} from 'vuex'
import { removeLoginPhone, removeToken, removeUUID } from '@/common/auth'
import store from '@/store'
import {
  reqLogout
} from '@/api'

export default {
  name: 'CustomerCenter',
  data() {
    return {
      phone: ''
    }
  },

  methods: {
    logout () {
      this.$confirm('确定退出系统吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await reqLogout()

        removeLoginPhone()
        const phone = ''
        await this.$store.dispatch('setPhone', {phone})

        removeToken()
        const token = ''
        await this.$store.dispatch('setToken', {token})

        removeUUID()
        await this.$router.replace('/login')
      }).catch(() => {
      })
    },

    gotoIndex () {
      this.$router.replace('/').catch(err => {})
    },

    gotoUpdatePassword () {
      this.$router.replace('/customerCenter/updatePassword').catch(err => {})
    },

    gotoOrderList () {
      this.$router.replace('/customerCenter/orderList').catch(err => {})
    },

    gotoVideoClickHistory () {
      this.$router.replace('/customerCenter/videoClickHistory').catch(err => {})
    },

    gotoMaterialClickHistory () {
      this.$router.replace('/customerCenter/materialClickHistory').catch(err => {})
    },

  },

  mounted () {
    this.phone = store.getters.phone
  },

  computed: {
    currentYear: function () {
      return new Date().getFullYear()
    },
    phone2 () {
      return this.phone.substr(0, 3) + '****' + this.phone.substr(7)
    },
  }
}
</script>

<style scoped>
  .aside {
    /*border: 1px solid orchid;*/
  }

  .aside-header {
    background-color: #c13532;
    height: 60px;
  }

  .el-header {
    background-color: #c13532;
    color: #333;
    line-height: 60px;
  }

  .el-footer {
    background-color: #fff;
    color: #666;
    line-height: 60px;
    font-size: 16px;
    text-align: center;
  }

  .el-aside {
    color: #fff;
  }

  #exitLogin:hover {
    cursor:pointer;
  }

</style>



// WEBPACK FOOTER //
// src/pages/CustomerCenter/CustomerCenter.vue